<template>
  <div>


    <fieldset>
		<h2>Waterdieren <span>Optioneel <a style="float: right; cursor: pointer; padding-left: 10px; text-decoration: underline; font-style: normal" @click="$emit('skip')">deze stap overslaan</a></span></h2>
		<p>
      Upload een foto van je bak met waterdieren en vul hieronder in hoeveel je van alle waterdieren gevonden hebt.
    </p>

		<ImageInput v-model="localMeasurement.photoWaterAnimals" label="Foto van je bak met waterdieren" name="photo_wateranimals"></ImageInput>

		<label>Zoek op naam</label>
		<input type="text" v-model="search" placeholder="Naam waterdier" />

		<div class="animal-wrapper">
			<AnimalCount
				v-for="animal in animals" :key="animal.key"
				:name="animal.key"
				:title="animal.name"
				v-model="localMeasurement[animal.key]"
				:img="animal.img"
				:class="{hidden: !isAnimalHitForSearch(animal)}"
				:focussed="animalFocus == animal.key"
				@grabFocus="animalFocus = animal.key"
				@blur="animalFocus = ''"
			/>

			<div class="checkbox">
				<SingleCheckbox
					name="measurement_noanimals"
					v-model="localMeasurement.noAnimals"
					label="Geen waterdieren"
					text="Er is wel geschept maar geen waterdieren gevonden"
				/>
			</div>
	
			<div v-if="totalCount > 0 && localMeasurement.noAnimals">
				Je hebt al waterdieren aangevinkt in je meting. Klopt dit?
			</div>

			<ImageInput 
					v-model="localMeasurement.larvae" 
					label="Upload hier een foto van de libellenlarve en/of jufferlarve als je die hebt gevonden." 
					name="photo_larvae"
					v-if="localMeasurement['libellenlarve'] || localMeasurement['jufferlarve']"
				>
			</ImageInput>
		</div>
    </fieldset>
    <nav>
      <button @click.prevent="$emit('back')" type="button" class="btn-prev">Terug</button>
      <button @click.prevent="$emit('save', localMeasurement)" class="btn-next" :disabled="!fieldsComplete">Volgende</button>
    </nav>
  </div>
</template>

<script>
import AnimalCount from "./components/AnimalCount";
import SingleCheckbox from "./components/SingleCheckbox.vue";
import FormStep from "./FormStep.vue";
import ImageInput from "./components/ImageInput.vue";

export default {
  name: "FormStep9",
	components: { AnimalCount, SingleCheckbox, ImageInput },
	data() {
		const imgPrefix = '/app/themes/natuur-en-milieu/campagnes/watermonsters/assets/images/diertjes/';
		return {
			search: '',
			animalFocus: '',
			animals: [
				{
					name: 'Zwemwants',
					key: 'zwemwants',
					img: imgPrefix+'Zwemwants.jpg',
				},
				{
					name: 'Bootsmannetje',
					key: 'bootsmannetje',
					img: imgPrefix+'Bootsmannetje.jpg',
				},
				{
					name: 'Grote spinnende watertor',
					key: 'grote_spinnende_watertor',
					img: imgPrefix+'Grote_spinnende_watertor.jpg',
				},
				{
					name: 'Duikerwants',
					key: 'duikerwants',
					img: imgPrefix+'Duikerwants.jpg',
				},
				{
					name: 'Schrijvertje',
					key: 'schrijvertje',
					img: imgPrefix+'Schrijvertje.jpg',
				},
				{
					name: 'Geelgerande watertor',
					key: 'geelgerande_watertor',
					img: imgPrefix+'Geelgerande_watertor.jpg',
				},
				{
					name: 'Waterschorpioen',
					key: 'waterschorpioen',
					img: imgPrefix+'Waterschorpioen.jpg',
				},
				{
					name: 'Overige waterkever(tje)s',
					key: 'overige_waterkevertjes',
				},
				{
					name: 'Haftenlarve',
					key: 'haftenlarve',
					img: imgPrefix+'Haftenlarve.jpg',
				},
				{
					name: 'Libellenlarve',
					key: 'libellenlarve',
					img: imgPrefix+'Libellenlarve.jpg',
				},
				{
					name: 'Steenvlieglarve',
					key: 'steenvlieglarve',
					img: imgPrefix+'Steenvlieglarve.jpg',
				},
				{
					name: 'Jufferlarve',
					key: 'jufferlarve',
					img: imgPrefix+'Jufferlarve.jpg',
				},
				{
					name: 'Schaatsenrijder',
					key: 'schaatsenrijder',
					img: imgPrefix+'Schaatsenrijder.jpg',
				},
				{
					name: 'Keverlarve',
					key: 'keverlarve',
					img: imgPrefix+'Keverlarve.jpg',
				},
				{
					name: 'Larve geelgerande watertor',
					key: 'larve_geelgerande_watertor',
					img: imgPrefix+'Larve_geelgerande_watertor.jpg',
				},
				{
					name: 'Slijkvlieglarve',
					key: 'slijkvlieglarve',
					img: imgPrefix+'Slijkvlieglarve.jpg',
				},
				{
					name: 'Staafwants',
					key: 'staafwants',
					img: imgPrefix+'Staafwants.jpg',
				},
				{
					name: 'Kokerjuffer zonder huisje',
					key: 'kokerjuffer_without_house',
					img: imgPrefix+'Kokerjuffer_zonder_huisje.jpg',
				},
				{
					name: 'Kokerjuffer met huisje',
					key: 'kokerjuffer_with_house',
					img: imgPrefix+'Kokerjuffer_met_huisje.jpg',
				},
				{
					name: 'Vlokreeft',
					key: 'vlokreeft',
					img: imgPrefix+'Vlokreeft.jpg',
				},
				{
					name: 'Waterpissebed',
					key: 'waterpissebed',
					img: imgPrefix+'Waterpissebed.jpg',
				},
				{
					name: 'Aasgarnaal',
					key: 'aasgarnaal',
					img: imgPrefix+'Aasgarnaal.jpg',
				},
				{
					name: 'Rivierkreeft',
					key: 'rivierkreeft',
					img: imgPrefix+'Rivierkreeft.jpg',
				},
				{
					name: 'Bloedzuiger',
					key: 'bloedzuiger',
					img: imgPrefix+'Bloedzuiger.jpg',
				},
				{
					name: 'Platworm',
					key: 'platworm',
					img: imgPrefix+'Platworm.jpg',
				},
				{
					name: 'Koordwormen',
					key: 'koordwormen',
					img: imgPrefix+'Koordwormen.jpg',
				},
				{
					name: 'Overige wormen',
					key: 'overige_wormen',
					img: imgPrefix+'Overige_wormen.jpg',
				},
				{
					name: 'Meniscusmug',
					key: 'meniscusmug',
					img: imgPrefix+'Meniscusmug.jpg',
				},
				{
					name: 'Dans- of vedermuglarve',
					key: 'dans_of_vedermuglarve',
					img: imgPrefix+'Dans_of_vedermuglarve.jpg',
				},
				{
					name: 'Langpootmuglarve',
					key: 'langpootmuglarve',
					img: imgPrefix+'Langpootmuglarve.jpg',
				},
				{
					name: 'Knaasje',
					key: 'knaasje',
					img: imgPrefix+'knaasje.jpg',
				},
				{
					name: 'Pop van een mug',
					key: 'pop_van_een_mug',
					img: imgPrefix+'Pop_van_een_mug.jpg',
				},
				{
					name: 'Pluimmuglarve',
					key: 'pluimmuglarve',
					img: imgPrefix+'Pluimmuglarve.jpg',
				},
				{
					name: 'Steekmuglarve',
					key: 'steekmuglarve',
					img: imgPrefix+'Steekmuglarve.jpg',
				},
				{
					name: 'Kriebelmuglarve',
					key: 'kriebelmuglarve',
					img: imgPrefix+'Kriebelmuglarve.jpg',
				},
				{
					name: 'Rattenstaartlarve',
					key: 'rattenstaartlarve',
					img: imgPrefix+'Rattestaartlarve.jpg',
				},
				{
					name: 'Watermijt',
					key: 'watermijt',
					img: imgPrefix+'Watermijt.jpg',
				},
				{
					name: 'Watervlooien',
					key: 'watervlooien',
					img: imgPrefix+'Watervlooien_2_van_2.jpg',
				},
				{
					name: 'Waterspin',
					key: 'waterspin',
					img: imgPrefix+'Waterspin.jpg',
				},
				{
					name: 'Poelslak',
					key: 'poelslak',
					img: imgPrefix+'Poelslak.jpg',
				},
				{
					name: 'Blaashoornslak',
					key: 'blaashoornslak',
					img: imgPrefix+'Blaashorenslak.jpg',
				},
				{
					name: 'Schijfhorenslak',
					key: 'schijfhorenslak',
					img: imgPrefix+'Schijfhorenslak.jpg',
				},
				{
					name: 'Posthoornslak',
					key: 'posthoornslak',
					img: imgPrefix+'Posthoornslak.jpg',
				},
				{
					name: 'Diepslak',
					key: 'diepslak',
					img: imgPrefix+'Diepslak.jpg',
				},
				{
					name: 'Overige slakjes',
					key: 'overige_slakjes',
				},
				{
					name: 'Kaphoornslak',
					key: 'kaphoornslak',
					img: imgPrefix+'Kaphorenslak.jpg',
				},
				{
					name: 'Horenschaal',
					key: 'horenschaal',
					img: imgPrefix+'Horenschaal.jpg',
				},
				{
					name: 'Driehoeksmossel',
					key: 'driehoeksmossel',
					img: imgPrefix+'Driehoeksmossel.jpg',
				},
				{
					name: 'Schilder-/zwanen-/eendenmossel',
					key: 'schilder_zwanen_eenden-mossel',
					img: imgPrefix+'Schildermossel.jpg',
				},
				{
					name: 'Korfmossel',
					key: 'korfmossel',
					img: imgPrefix+'korfmossel.jpg',
				},
			],
		}
	},
  	mixins: [FormStep],
	computed: {
		totalCount(){
			return this.animals
					//aantallen pakken
					.map(animal => parseInt(this.measurement[animal.key] || 0))
					//bij elkaar optellen
					.reduce((carry, count) => parseInt(carry) + parseInt(count), 0);
		},
		fieldsComplete(){
			return this.totalCount > 0 || this.localMeasurement.noAnimals;
		}
	},
	methods: {
		isAnimalHitForSearch(animal){
			if(this.search == ''){
				return true;
			}
			return animal.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
		}
	},
}
</script>

<style scoped>
input[type="text"] {
  padding: 21px 18px 19px 18px;
  border-radius: 7px;
  border: solid 1px #dadde2;
  background-color: #fff;
  width: 100%;
  font-size: 1.6rem;
}

input[type="text"]:focus {
  outline: none;
  box-shadow:0px 0px 0px 3px #da503b inset;
}

.animal-wrapper {
	position: relative;
	margin-top: 20px;

}
.animal-wrapper:after {
	content: '';
	display: block;
	height: 1px;
	position: absolute;
	top: 0;
	left: -5vw;
	right: -5vw;
	background-color: #d8dbde;
}

.checkbox {
	margin-top: 40px;
}

</style>
